module.exports = "/cyber/_next/static/images/vesenniiBannerItogiDesktop-0545d5a4a25fb97f5516fda8e84de69a.jpg";